import React, { FC } from 'react';
import Spacer from '@fenderdigital/ui/Spacer';
import BodyText from '@fenderdigital/ui/BodyText';
import Flex from '@fenderdigital/ui/Flex';
import { Results } from '../SearchResults';
import ResultItem from '../ResultItem';

interface CategoryProps {
  results: Results[];
  type?: string;
  onClick: (e: any) => void;
  selectedOptionId?: string | null;
}


const CollectionsResults: FC<CategoryProps> = ({ results, type, onClick, selectedOptionId }) => {
  return (
    <>
      <Spacer spacing="md2" />
      <Flex direction="column" as="ul" dataId={`${type?.toLowerCase()}`}>
        <li role="presentation">
          <BodyText
            fontFamily="futuraDemi"
            textSize="f4"
            textColor="midGray"
            textTransform="capitalize"
            css={`
              line-height: 1;
            `}
          >
            {type}
          </BodyText>
          <Spacer spacing="md1" />
        </li>
        {results.map(item => {
          const instrument = item?.instrument?.includes('guitar') ? 'guitar' : item?.instrument;
          const rowId =
            type === 'Artists' ? `artist-${item?.title}` : `${item?.objectType}-${item?.slug}`;
          return (
            <ResultItem
              result={item}
              rowId={rowId}
              selectedOptionId={selectedOptionId}
              onClick={onClick}
              type={type}
              instrument={instrument}
            />
          );
        })}
      </Flex>
      <Spacer spacing="md2" />
    </>
  );
};

export default CollectionsResults;
